import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  tr: {
    translation: {
      // Örnek çeviriler, daha sonra genişletilecek
      welcome: "Hoşgeldiniz",
      submit: "Gönder",
      description: "Açıklama",
      date: "Tarih",
      assigned_forms: "Atanan Formlarınız",
      my_forms: "Formlarım",
      responses: "Yanıtlarım",
      form_responses: "Form Yanıtlarınız",
      forms: "Formlar",
      view: "Görüntüle",
      logout: "Çıkış",
      invalid_name: "Geçerli bir ad soyad girin",
      file_upload: "Dosya Yükleme",
      file_upload_desc: "PDF, Word, Excel gibi dosyaları yüklemek için",
      total_form: "Toplam Form",
      active_form: "Aktif Form",
      record_form: "Yanıtlananlar",
      archive_form: "Arşiv Formu",
      all: "Tümü",
      survey: "Anket",
      application: "Başvuru",
      evaluation: "Değerlendirme",
      hr: "İK",
      marketing: "Pazarlama",
      education: "Eğitim",
      event: "Etkinlik",
      customer_satisfaction_survey: "Müşteri Memnuniyet Anketi",
      customer_satisfaction_survey_desc:
        "Müşterilerinizin deneyimlerini değerlendirmek için kapsamlı bir anket.",
      application_form: "İş Başvuru Formu",
      application_form_desc:
        "Adaylardan bilgi toplamak için profesyonel bir başvuru formu.",
      employee_evaluation_form: "Çalışan Değerlendirme Formu",
      employee_evaluation_form_desc:
        "Çalışanların performansını değerlendirmek için kapsamlı bir form.",
      student_feedback_form: "Öğrenci Geri Bildirim Formu",
      student_feedback_form_desc:
        "Öğrencilerden ders ve eğitim hakkında geri bildirim almak için form.",
      event_registration_form: "Etkinlik Kayıt Formu",
      event_registration_form_desc:
        "Katılımcıları etkinliğinize kaydetmek için kullanışlı bir form.",
      market_research_survey: "Pazar Araştırması Anketi",
      market_research_survey_desc:
        "Hedef kitlenizden veri toplamak için kapsamlı bir anket.",
      form_design_tips: "Form Tasarım İpuçları",
      form_design_tips_desc:
        "Kullanıcı dostu ve etkili formlar oluşturmak için en iyi uygulamalar.",
      video_tutorial: "Video Eğitimi: İleri Seviye Form Oluşturma",
      video_tutorial_desc:
        "Koşullu mantık ve hesaplamalar gibi ileri seviye özellikleri kullanmayı öğrenin.",
      form_analytics_guide: "Form Analitiği Rehberi",
      form_analytics_guide_desc:
        "Form yanıtlarınızı analiz etmek ve anlamlı içgörüler elde etmek için ipuçları.",
      good_morning: "Günaydın",
      good_day: "İyi Günler",
      good_evening: "İyi Akşamlar",
      user: "Kullanıcı",
      hotel: "Otel",
      dashboard_welcome: "Form yönetim paneline hoş geldiniz",
      statistics: "İstatistikler",
      loading_data: "Veriler Yükleniyor...",
      form_templates: "Form Şablonları",
      create_new_form: "+ Yeni Form Oluştur",
      usage: "kullanım",
      new_form: "Yeni Form",
      preview: "Önizle",
      save: "Kaydet",
      edit: "Düzenle",
      settings: "Ayarlar",
      add_logo: "Logo Ekle",
      form_title: "Form Başlığı",
      form_description: "Form Açıklaması",
      folders: "Klasörler",
      add_to_folder: "Klasöre Ekle",
      no_folder_selected: "Henüz bir klasör seçilmedi",
      step: "Adım",
      back: "Geri",
      add_page: "+ Sayfa Ekle",
      delete_page: "Sayfayı Sil",
      next: "İleri",
      add_form_to_folder: "Formu Klasöre Ekle",
      select_folders_for_form:
        '"{{formTitle}}" formunu eklemek istediğiniz klasörleri seçin',
      selected_folders: "Seçilen Klasörler:",
      cancel: "İptal",
      ok: "Tamam",
      form_preview: "Form Önizleme",
      desktop: "Masaüstü",
      tablet: "Tablet",
      mobile: "Mobil",
      form_link: "Form Bağlantısı",
      close: "Kapat",
      view_form: "Formu Görüntüle",
      move_up: "Yukarı Taşı",
      move_down: "Aşağı Taşı",
      copy_page: "Sayfayı Kopyala",
      folder_structure: "Klasör Yapısı",
      form_builder: "Form Oluşturucu",
      drag_or_click_to_add_field:
        "Form alanı eklemek için soldaki menüden bir alan sürükleyin veya tıklayın",
      link_copied: "Bağlantı kopyalandı",
      form_saved: "Form kaydedildi",
      form_save_error: "Form kaydedilirken bir hata oluştu",
      folder_load_error: "Klasörler yüklenirken hata oluştu",
      pdf_success: "PDF başarıyla oluşturuldu",
      pdf_error: "PDF oluşturulurken hata oluştu",
      select_page: "Sayfa Seç",
      remove: "Kaldır",
      add: "Ekle",
      short_text: "Kısa Metin",
      short_text_desc: "Tek satır metin girişi için",
      long_text: "Uzun Metin",
      long_text_desc: "Çok satırlı metin girişi için",
      paragraph: "Paragraf",
      paragraph_desc: "Form üzerinde görüntülenecek sabit metin/açıklama için",
      email: "E-posta",
      email_desc: "E-posta adresi girişi için",
      phone: "Telefon",
      phone_desc: "Telefon numarası girişi için",
      number: "Sayı",
      number_desc: "Sayısal değer girişi için",
      dropdown: "Açılır Liste",
      dropdown_desc: "Tek seçimlik liste için",
      checkbox: "Çoklu Seçim",
      checkbox_desc: "Çoklu seçim için",
      radio: "Seçenek Düğmeleri",
      radio_desc: "Tek seçimlik seçenekler için",
      image_upload: "Görsel Yükleme",
      image_upload_desc: "Resim dosyalarını yüklemek için",
      pdf_upload: "PDF Yükleme",
      pdf_upload_desc: "Kullanıcılar formla birlikte PDF dosyası yükleyebilir",
      pdf_document: "PDF Doküman Eki",
      pdf_document_desc:
        "Form oluşturan kişi PDF dokümanı ekler, form yanıtlayanlar bu PDF'i görüntüleyerek formu doldurur",
      name: "Ad Soyad",
      name_desc: "Ad ve soyad girişi için",
      conditional_field: "Koşullu Alan",
      conditional_field_desc: "Seçime bağlı olarak görüntülenen alan için",
      signature: "İmza",
      signature_desc: "İmza alanı için",
      time: "Saat",
      time_desc: "Saat girişi için",
      table: "Tablo",
      table_desc: "Tablo eklemek için",
      calculation: "Hesaplama",
      calculation_desc: "Excel benzeri formül ve hesaplama yapabilmek için",
      address: "Adres",
      address_desc:
        "Adres bilgisi için (il, ilçe, mahalle, sokak, bina no, daire no)",
      basic_fields: "Temel Alanlar",
      personal_info: "Kişisel Bilgiler",
      selectable_fields: "Seçilebilir Alanlar",
      date_and_time: "Tarih ve Zaman",
      file_upload_category: "Dosya Yükleme",
      other_fields: "Diğer Alanlar",
      placeholder: "Placeholder",
      required_field: "Zorunlu Alan",
      options: "Seçenekler",
      add_option: "Seçenek Ekle",
      conditional_field_settings: "Koşullu Alan Ayarları",
      title: "Başlık",
      placeholder_text: "Placeholder Metni",
      add_condition: "Koşul Ekle",
      new_column_add: "Yeni Sütun Ekle",
      table_configuration: "Tablo Yapılandırması",
      minimum_row: "Minimum Satır",
      maximum_row: "Maksimum Satır",
      show_row_count: "Satır Sayısını Göster",
      column_header: "Sütun Başlığı",
      type: "Tip",
      text: "Metin",
      select: "Seçim",
      full_width_12: "Tam Genişlik (12)",
      side_by_side_6: "Yan Yana (6)",
      triple_4: "Üçlü (4)",
      help_text: "Açıklama",
      label: "Etiket",
      first_name: "Ad",
      last_name: "Soyad",
      address_information: "Adres Bilgisi",
      city: "İl",
      district: "İlçe",
      neighborhood: "Mahalle",
      street: "Sokak",
      building_number: "Bina No",
      apartment_number: "Daire No",
      file_upload_area: "Dosya Yükleme Alanı",
      image_upload_area: "Görsel Yükleme Alanı",
      pdf_upload_area: "PDF Yükleme Alanı",
      signature_area: "İmza Alanı",
      drag: "Sürükle",
      duplicate: "Çoğalt",
      option: "Seçenek",
      my_forms: "Formlarım",
      search_form: "Form Ara...",
      status: "Durum",
      active: "Aktif",
      passive: "Pasif",
      sort: "Sıralama",
      newest: "En Yeni",
      oldest: "En Eski",
      response: "Yanıt",
      actions: "İşlemler",
      view: "Görüntüle",
      share: "Paylaş",
      archive: "Arşiv",
      delete: "Sil",
      export_pdf: "PDF Olarak Dışa Aktar",
      form_responses: "Form Yanıtları",
      refresh: "Yenile",
      search_tooltip:
        "Form adı, kullanıcı veya form numarasına göre arama yapabilirsiniz",
      search_form_placeholder: "Form adı, kullanıcı veya form no",
      start_date_tooltip:
        "Formların oluşturma tarihi için başlangıç tarihini seçin",
      start_date: "Başlangıç Tarihi",
      end_date_tooltip: "Formların oluşturma tarihi için bitiş tarihini seçin",
      end_date: "Bitiş Tarihi",
      clear_filters: "Tüm filtreleri temizle",
      clear: "Temizle",
      created_at: "Oluşturma Tarihi",
      updated_at: "Düzenleme Tarihi",
      untitled_form: "İsimsiz Form",
      view_details: "Detayları Görüntüle",
      loading: "Yükleniyor...",
      no_results: "Sonuç bulunamadı",
      new_folder: "Yeni Klasör",
      selected_folder: "Seçilen Klasör",
      forms: "Formlar",
      all_forms: "Tüm Formlar",
      create_subfolder: "Alt Klasör Oluştur",
      create_new_folder: "Yeni Klasör Oluştur",
      folder_name: "Klasör Adı",
      subfolder_info:
        'Bu klasör, "{{folderName}}" klasörünün altına eklenecektir.',
      create: "Oluştur",
      no_form_description: "Form açıklaması bulunmuyor",
      last_update: "Son güncelleme",
      not_specified: "Belirtilmemiş",
      move_to_folder: "Klasöre Taşı",
      move_form_to_folder: "Formu Klasöre Taşı",
      loading_folders: "Klasörler yükleniyor...",
      select_folders_to_move:
        '"{{formTitle}}" formunu taşımak istediğiniz klasörleri seçin',
      moving: "Taşınıyor",
      move: "Taşı",
      delete_folder_confirm:
        '"{{folderName}}" klasörünü silmek istediğinizden emin misiniz?',
      folder_operations: "Klasör İşlemleri",
      add_subfolder: "Alt Klasör Ekle",
      delete_folder: "Klasörü Sil",
      main_folder: "Ana Klasör",
      no_folders_yet: "Henüz klasör bulunmuyor",
      creating: "Oluşturuluyor...",
      session_info_not_found:
        "Oturum bilgileri bulunamadı, lütfen tekrar giriş yapın",
      untitled_folder: "İsimsiz Klasör",
      folder_data_error: "Klasör verileri alınamadı",
      folder_load_error_message: "Klasörleri yüklerken hata oluştu: {{error}}",
      select_folders: "Klasör seçin",
      folder_fetch_error: "Klasörleri çekerken hata oluştu:",
      select_folder: "Klasör Seç",
      no_folders_found: "Klasör bulunamadı.",
      tags_mode: "Etiket Modu",
      no_forms_in_folder: "Bu klasörde henüz form yok.",
      start_by_creating_new_form: "Yeni bir form oluşturarak başlayın.",
      create_first_form: "İlk Formunu Oluştur",
      error_no_folder_selected: "Hata: Seçili bir klasör yok.",
      please_select_folder_first: "Lütfen önce bir klasör seçin.",
      form_added_to_folder:
        "Form {{formId}}, klasör ({{folderId}}) içine eklendi.",
      folder_add_failed: "Klasöre ekleme başarısız.",
      folder_add_error: "Klasöre ekleme hatası:",
      folder_add_error_message:
        "Klasöre ekleme sırasında hata oluştu: {{error}}",
      home: "Anasayfa",
      create_form: "Form Oluştur",
      responses: "Yanıtlar",
      create_folder: "Klasör Oluştur",
      deleted_items: "Silinenler",
      main_menu: "ANA MENÜ",
      archive_management: "DOSYA YÖNETİMİ",
      form_clicker: "Form Clicker",
      discover_forms_digitally: "Formlarınızı dijitalde keşfedin",
      profile: "Profil",
      logout: "Çıkış Yap",
      notifications: "Bildirimler",
      new_form_response: "Yeni form yanıtı",
      new_response_customer_satisfaction:
        '"Müşteri Memnuniyet Anketi" formuna yeni bir yanıt geldi',
      "2_hours_ago": "2 saat önce",
      form_shared: "Form paylaşıldı",
      job_application_form_viewed:
        '"İş Başvuru Formu" 5 kişi tarafından görüntülendi',
      yesterday: "Dün",
      system_notification: "Sistem bildirimi",
      new_features_added: "Yeni özellikler eklendi! Form şablonlarını keşfedin",
      "3_days_ago": "3 gün önce",
      view_all_notifications: "Tüm Bildirimleri Gör",
      submitted: "Gönderilme",
      and: "ve",
      more_fields: "alan daha",
      has_signature: "İmza var",
      files: "Dosya",
      form_response_details: "Form Yanıt Detayları",
      form_data: "Form Verileri",
      download_response: "Yanıtı İndir",
      archived_forms_load_error: "Arşivlenmiş formlar yüklenirken hata oluştu:",
      form_restored_successfully: "Form başarıyla geri yüklendi",
      form_restore_error: "Form geri yüklenirken hata oluştu:",
      form_restore_error_message: "Form geri yüklenirken bir hata oluştu",
      form_delete_error: "Form silinirken hata oluştu:",
      form_id: "Form ID",
      created_date: "Oluşturulma Tarihi",
      updated_date: "Güncellenme Tarihi",
      restore: "Geri Yükle",
      archived_forms: "Arşivlenen Formlar",
      total_records: "Toplam {{count}} kayıt",
      no_archived_forms: "Arşivlenmiş form bulunmamaktadır.",
      deleted_items_load_error: "Silinen öğeler yüklenirken hata oluştu:",
      deleted_forms_load_error_message:
        "Silinen formlar yüklenirken bir hata oluştu",
      confirm_restore_form: "Formu Geri Yüklemek İstediğinizden Emin misiniz?",
      yes_restore: "Evet, Geri Yükle",
      restoring_form: "Form geri yükleniyor...",
      restore_error: "Geri yükleme sırasında hata oluştu:",
      deleted_forms: "Silinen Formlar",
      no_deleted_forms: "Silinen form bulunmamaktadır.",
      appearance_settings: "Görünüm Ayarları",
      form_title: "Form Başlığı",
      form_description_preview:
        "Form açıklaması bu alanda görünür. Kullanıcılara formu doldururken rehberlik eder.",
      sample_form_field: "Örnek Form Alanı",
      font_family: "Yazı Tipi",
      font_size: "Yazı Boyutu",
      field_size: "Alan Boyutu",
      form_width: "Form Genişliği",
      submit_button_text: "Gönder Butonu Metni",
      submit_button_text_help: "Form gönderme düğmesinde görünecek metin",
      color_settings: "Renk Ayarları",
      background_color: "Arka Plan Rengi",
      title_color: "Başlık Rengi",
      description_color: "Açıklama Rengi",
      button_color: "Buton Rengi",
      button_text_color: "Buton Metin Rengi",
      field_border_color: "Alan Kenarlık Rengi",
      field_focus_color: "Alan Odaklanma Rengi",
      small: "Küçük",
      medium: "Orta",
      large: "Büyük",
      narrow: "Dar",
      wide: "Geniş",
      full_width: "Tam Genişlik",
      document_control_system: "Doküman Kontrol Sistemi",
      show_document_info_on_form: "Form üzerinde doküman bilgilerini göster",
      document_code_prefix: "Doküman Kodu Öneki",
      document_code_prefix_example: "Örn: FRM",
      document_code_prefix_help: "Doküman kodu öneki",
      document_number: "Doküman Numarası",
      document_number_help: "Doküman numarası",
      department: "Departman",
      department_example: "Örn: Kalite Kontrol",
      department_help: "Dokümanın ait olduğu departman",
      document_preview: "Doküman Önizleme",
      document_preview_help: "Form başlığının üzerinde bu şekilde görünecek",
      animation_and_effects: "Animasyon ve Efektler",
      animations: "Animasyonlar",
      add_animation_effects_to_form_fields:
        "Form alanlarına animasyon efektleri ekle",
      animation_type: "Animasyon Tipi",
      fade: "Solma",
      slide: "Kaydırma",
      bounce: "Zıplama",
      scale: "Ölçeklendirme",
      form_fields_appearance_animation: "Form alanlarının görünme animasyonu",
      accessibility: "Erişilebilirlik",
      accessibility_features: "Erişilebilirlik Özellikleri",
      enable_form_accessibility_features:
        "Form erişilebilirlik özelliklerini etkinleştir",
      high_contrast_mode: "Yüksek Kontrast Modu",
      high_contrast_mode_help:
        "Daha yüksek kontrast oranları için optimize edilmiş görünüm",
      security: "Güvenlik",
      security_features: "Güvenlik Özellikleri",
      enable_form_security_features: "Form güvenlik özelliklerini etkinleştir",
      captcha_protection: "CAPTCHA Koruması",
      captcha_protection_help:
        "Otomatik form gönderimlerini engellemek için CAPTCHA ekle",
      max_submissions: "Maksimum Gönderim Sayısı",
      max_submissions_help: "Form için izin verilen maksimum gönderim sayısı",
      settings_saved_successfully: "Ayarlarınız başarıyla kaydedildi!",
      unsaved_changes_warning:
        'Kaydedilmemiş değişiklikleriniz var. Değişiklikleri uygulamak için "Kaydet" düğmesine tıklayın.',
      appearance: "Görünüm",
      document: "Doküman",
      animation: "Animasyon",
      unsaved_changes: "Kaydedilmemiş değişiklikler var",
      saving: "Kaydediliyor...",
      save_changes: "Değişiklikleri Kaydet",
      pdf_file_only: "Sadece PDF dosyaları yükleyebilirsiniz",
      pdf_size_limit: "PDF dosyası çok büyük",
      pdf_upload_success: "PDF başarıyla yüklendi",
      pdf_upload_error: "PDF yüklenirken hata oluştu",
      pdf_delete_success: "PDF başarıyla silindi",
      pdf_preview: "PDF Önizleme",
      pdf_download: "PDF İndir",
      upload_pdf: "PDF Yükle",
      drop_pdf_here: "PDF dosyasını buraya sürükleyin",
      pdf_max_size: "Maksimum PDF boyutu: {{size}}",
      no_logo_available: "Logo mevcut değil",
      file_type: "Dosya Tipi",
      standard_form: "Standart Form",
      advanced_form: "Gelişmiş Form",
      select_file_type: "Dosya Tipi Seç",
      all_types: "Tüm Tipler",
      form: "Form",
      table: "Tablo",
      confirm_save_form: "Onay",
      save_confirmation_message: "Bu formu kaydetmek istiyor musunuz?",
      form_details: "Form Detayları",
      field_count: "Alan Sayısı",
      fields: "alan",
      save_warning:
        "Bu işlem geri alınamaz. Form kaydedildikten sonra değişiklikleriniz kalıcı olacaktır.",
      save_form: "Formu Kaydet",
      saving_form: "Form Kaydediliyor...",
      loginRequiredControl: "Formu doldurmak için giriş zorunluluğu ayarı",
    },
  },
  en: {
    translation: {
      welcome: "Welcome",
      submit: "Submit",
      description: "Description",
      date: "Date",
      assigned_forms: "Your Assigned Forms",
      my_forms: "My Forms",
      responses: "My Responses",
      form_responses: "Form Responses",
      forms: "Forms",
      view: "View",
      logout: "Logout",
      invalid_name: "Please enter a valid name and surname",
      file_upload: "File Upload",
      file_upload_desc: "To upload files like PDF, Word, Excel",
      total_form: "Total Forms",
      active_form: "Active Forms",
      record_form: "Record Forms",
      archive_form: "Archive Forms",
      all: "All",
      survey: "Survey",
      application: "Application",
      evaluation: "Evaluation",
      hr: "HR",
      marketing: "Marketing",
      education: "Education",
      event: "Event",
      customer_satisfaction_survey: "Customer Satisfaction Survey",
      customer_satisfaction_survey_desc:
        "A comprehensive survey to evaluate your customers' experiences.",
      application_form: "Job Application Form",
      application_form_desc:
        "A professional application form to collect information from candidates.",
      employee_evaluation_form: "Employee Evaluation Form",
      employee_evaluation_form_desc:
        "A comprehensive form to evaluate employee performance.",
      student_feedback_form: "Student Feedback Form",
      student_feedback_form_desc:
        "A form to collect feedback from students about courses and education.",
      event_registration_form: "Event Registration Form",
      event_registration_form_desc:
        "A handy form to register participants for your event.",
      market_research_survey: "Market Research Survey",
      market_research_survey_desc:
        "A comprehensive survey to collect data from your target audience.",
      form_design_tips: "Form Design Tips",
      form_design_tips_desc:
        "Best practices for creating user-friendly and effective forms.",
      video_tutorial: "Video Tutorial: Advanced Form Building",
      video_tutorial_desc:
        "Learn to use advanced features like conditional logic and calculations.",
      form_analytics_guide: "Form Analytics Guide",
      form_analytics_guide_desc:
        "Tips for analyzing your form responses and gaining meaningful insights.",
      good_morning: "Good Morning",
      good_day: "Good Day",
      good_evening: "Good Evening",
      user: "User",
      hotel: "Hotel",
      dashboard_welcome: "Welcome to the form management panel",
      statistics: "Statistics",
      loading_data: "Loading Data...",
      form_templates: "Form Templates",
      create_new_form: "+ Create New Form",
      usage: "usage",
      new_form: "New Form",
      preview: "Preview",
      save: "Save",
      edit: "Edit",
      settings: "Settings",
      add_logo: "Add Logo",
      form_title: "Form Title",
      form_description: "Form Description",
      folders: "Folders",
      add_to_folder: "Add to Folder",
      no_folder_selected: "No folder selected yet",
      step: "Step",
      back: "Back",
      add_page: "+ Add Page",
      delete_page: "Delete Page",
      next: "Next",
      add_form_to_folder: "Add Form to Folder",
      select_folders_for_form: 'Select folders for "{{formTitle}}" form',
      selected_folders: "Selected Folders:",
      cancel: "Cancel",
      ok: "OK",
      form_preview: "Form Preview",
      desktop: "Desktop",
      tablet: "Tablet",
      mobile: "Mobile",
      form_link: "Form Link",
      close: "Close",
      view_form: "View Form",
      move_up: "Move Up",
      move_down: "Move Down",
      copy_page: "Copy Page",
      folder_structure: "Folder Structure",
      form_builder: "Form Builder",
      drag_or_click_to_add_field:
        "Drag or click a field from the left menu to add",
      link_copied: "Link copied",
      form_saved: "Form saved",
      form_save_error: "An error occurred while saving the form",
      folder_load_error: "An error occurred while loading folders",
      pdf_success: "PDF created successfully",
      pdf_error: "An error occurred while creating PDF",
      select_page: "Select Page",
      remove: "Remove",
      add: "Add",
      short_text: "Short Text",
      short_text_desc: "For single-line text input",
      long_text: "Long Text",
      long_text_desc: "For multi-line text input",
      paragraph: "Paragraph",
      paragraph_desc: "For static text/description to be displayed on the form",
      email: "Email",
      email_desc: "For email address input",
      phone: "Phone",
      phone_desc: "For phone number input",
      number: "Number",
      number_desc: "For numeric value input",
      dropdown: "Dropdown",
      dropdown_desc: "For single-select list",
      checkbox: "Checkbox",
      checkbox_desc: "For multiple selection",
      radio: "Radio Buttons",
      radio_desc: "For single-select options",
      image_upload: "Image Upload",
      image_upload_desc: "To upload image files",
      pdf_upload: "PDF Upload",
      pdf_upload_desc: "Users can upload PDF files with the form",
      pdf_document: "PDF Document Attachment",
      pdf_document_desc:
        "Form creator adds PDF document, form respondents view this PDF to fill out the form",
      name: "Name Surname",
      name_desc: "For name and surname input",
      conditional_field: "Conditional Field",
      conditional_field_desc: "For fields displayed based on selection",
      signature: "Signature",
      signature_desc: "For signature field",
      time: "Time",
      time_desc: "For time input",
      table: "Table",
      table_desc: "To add a table",
      calculation: "Calculation",
      calculation_desc: "To perform Excel-like formula and calculation",
      address: "Address",
      address_desc:
        "For address information (city, district, neighborhood, street, building no, apartment no)",
      basic_fields: "Basic Fields",
      personal_info: "Personal Info",
      selectable_fields: "Selectable Fields",
      date_and_time: "Date and Time",
      file_upload_category: "File Upload",
      other_fields: "Other Fields",
      placeholder: "Placeholder",
      required_field: "Required Field",
      options: "Options",
      add_option: "Add Option",
      conditional_field_settings: "Conditional Field Settings",
      title: "Title",
      placeholder_text: "Placeholder Text",
      add_condition: "Add Condition",
      new_column_add: "Add New Column",
      table_configuration: "Table Configuration",
      minimum_row: "Minimum Row",
      maximum_row: "Maximum Row",
      show_row_count: "Show Row Count",
      column_header: "Column Header",
      type: "Type",
      text: "Text",
      select: "Select",
      full_width_12: "Full Width (12)",
      side_by_side_6: "Side by Side (6)",
      triple_4: "Triple (4)",
      help_text: "Help Text",
      label: "Label",
      first_name: "First Name",
      last_name: "Last Name",
      address_information: "Address Information",
      city: "City",
      district: "District",
      neighborhood: "Neighborhood",
      street: "Street",
      building_number: "Building No",
      apartment_number: "Apartment No",
      file_upload_area: "File Upload Area",
      image_upload_area: "Image Upload Area",
      pdf_upload_area: "PDF Upload Area",
      signature_area: "Signature Area",
      drag: "Drag",
      duplicate: "Duplicate",
      option: "Option",
      my_forms: "My Forms",
      search_form: "Search Form...",
      status: "Status",
      active: "Active",
      passive: "Passive",
      sort: "Sort",
      newest: "Newest",
      oldest: "Oldest",
      response: "Response",
      actions: "Actions",
      view: "View",
      share: "Share",
      archive: "Archive",
      delete: "Delete",
      export_pdf: "Export as PDF",
      form_responses: "Form Responses",
      refresh: "Refresh",
      search_tooltip: "You can search by form name, user or form number",
      search_form_placeholder: "Form name, user or form no",
      start_date_tooltip: "Select the start date for form creation date",
      start_date: "Start Date",
      end_date_tooltip: "Select the end date for form creation date",
      end_date: "End Date",
      clear_filters: "Clear all filters",
      clear: "Clear",
      created_at: "Created At",
      updated_at: "Updated At",
      untitled_form: "Untitled Form",
      view_details: "View Details",
      loading: "Loading...",
      no_results: "No results found",
      new_folder: "New Folder",
      selected_folder: "Selected Folder",
      forms: "Forms",
      all_forms: "All Forms",
      create_subfolder: "Create Subfolder",
      create_new_folder: "Create New Folder",
      folder_name: "Folder Name",
      subfolder_info:
        'This folder will be added under the "{{folderName}}" folder.',
      create: "Create",
      no_form_description: "No form description available",
      last_update: "Last update",
      not_specified: "Not specified",
      move_to_folder: "Move to Folder",
      move_form_to_folder: "Move Form to Folder",
      loading_folders: "Loading folders...",
      select_folders_to_move:
        'Select the folders you want to move the "{{formTitle}}" form to',
      moving: "Moving",
      move: "Move",
      delete_folder_confirm:
        'Are you sure you want to delete the "{{folderName}}" folder?',
      folder_operations: "Folder Operations",
      add_subfolder: "Add Subfolder",
      delete_folder: "Delete Folder",
      main_folder: "Main Folder",
      no_folders_yet: "No folders yet",
      creating: "Creating...",
      session_info_not_found:
        "Session information not found, please login again",
      untitled_folder: "Untitled Folder",
      folder_data_error: "Could not get folder data",
      folder_load_error_message:
        "Error occurred while loading folders: {{error}}",
      select_folders: "Select folders",
      folder_fetch_error: "Error occurred while fetching folders:",
      select_folder: "Select Folder",
      no_folders_found: "No folders found.",
      tags_mode: "Tags Mode",
      no_forms_in_folder: "No forms in this folder yet.",
      start_by_creating_new_form: "Start by creating a new form.",
      create_first_form: "Create Your First Form",
      error_no_folder_selected: "Error: No folder selected.",
      please_select_folder_first: "Please select a folder first.",
      form_added_to_folder:
        "Form {{formId}} has been added to folder ({{folderId}}).",
      folder_add_failed: "Failed to add to folder.",
      folder_add_error: "Folder add error:",
      folder_add_error_message:
        "An error occurred while adding to folder: {{error}}",
      home: "Home",
      create_form: "Create Form",
      responses: "Responses",
      create_folder: "Create Folder",
      deleted_items: "Deleted Items",
      main_menu: "MAIN MENU",
      archive_management: "ARCHIVE MANAGEMENT",
      form_clicker: "Form Clicker",
      discover_forms_digitally: "Discover your forms digitally",
      profile: "Profile",
      logout: "Logout",
      notifications: "Notifications",
      new_form_response: "New form response",
      new_response_customer_satisfaction:
        'A new response came to "Customer Satisfaction Survey" form',
      "2_hours_ago": "2 hours ago",
      form_shared: "Form shared",
      job_application_form_viewed: '"Job Application Form" viewed by 5 people',
      yesterday: "Yesterday",
      system_notification: "System notification",
      new_features_added: "New features added! Discover form templates",
      "3_days_ago": "3 days ago",
      view_all_notifications: "View All Notifications",
      submitted: "Submitted",
      and: "and",
      more_fields: "more fields",
      has_signature: "Has signature",
      files: "Files",
      form_response_details: "Form Response Details",
      form_data: "Form Data",
      download_response: "Download Response",
      archived_forms_load_error: "Error occurred while loading archived forms:",
      form_restored_successfully: "Form restored successfully",
      form_restore_error: "Error occurred while restoring form:",
      form_restore_error_message: "An error occurred while restoring the form",
      form_delete_error: "Error occurred while deleting form:",
      form_id: "Form ID",
      created_date: "Created Date",
      updated_date: "Updated Date",
      restore: "Restore",
      archived_forms: "Archived Forms",
      total_records: "Total {{count}} records",
      no_archived_forms: "No archived forms found.",
      deleted_items_load_error: "Error occurred while loading deleted items:",
      deleted_forms_load_error_message:
        "An error occurred while loading deleted forms",
      confirm_restore_form: "Are you sure you want to restore the form?",
      yes_restore: "Yes, Restore",
      restoring_form: "Restoring form...",
      restore_error: "Error occurred during restore:",
      deleted_forms: "Deleted Forms",
      no_deleted_forms: "No deleted forms found.",
      appearance_settings: "Appearance Settings",
      form_title: "Form Title",
      form_description_preview:
        "Form description appears in this area. Guides users while filling out the form.",
      sample_form_field: "Sample Form Field",
      font_family: "Font Family",
      font_size: "Font Size",
      field_size: "Field Size",
      form_width: "Form Width",
      submit_button_text: "Submit Button Text",
      submit_button_text_help:
        "Text that will appear on the form submit button",
      color_settings: "Color Settings",
      background_color: "Background Color",
      title_color: "Title Color",
      description_color: "Description Color",
      button_color: "Button Color",
      button_text_color: "Button Text Color",
      field_border_color: "Field Border Color",
      field_focus_color: "Field Focus Color",
      small: "Small",
      medium: "Medium",
      large: "Large",
      narrow: "Narrow",
      wide: "Wide",
      full_width: "Full Width",
      document_control_system: "Document Control System",
      show_document_info_on_form: "Show document information on form",
      document_code_prefix: "Document Code Prefix",
      document_code_prefix_example: "Ex: FRM",
      document_code_prefix_help: "Document code prefix",
      document_number: "Document Number",
      document_number_help: "Document number",
      department: "Department",
      department_example: "Ex: Quality Control",
      department_help: "Department to which the document belongs",
      document_preview: "Document Preview",
      document_preview_help: "Will appear above the form title like this",
      animation_and_effects: "Animation and Effects",
      animations: "Animations",
      add_animation_effects_to_form_fields:
        "Add animation effects to form fields",
      animation_type: "Animation Type",
      fade: "Fade",
      slide: "Slide",
      bounce: "Bounce",
      scale: "Scale",
      form_fields_appearance_animation: "Form fields appearance animation",
      accessibility: "Accessibility",
      accessibility_features: "Accessibility Features",
      enable_form_accessibility_features: "Enable form accessibility features",
      high_contrast_mode: "High Contrast Mode",
      high_contrast_mode_help: "Optimized view for higher contrast ratios",
      security: "Security",
      security_features: "Security Features",
      enable_form_security_features: "Enable form security features",
      captcha_protection: "CAPTCHA Protection",
      captcha_protection_help:
        "Add CAPTCHA to prevent automatic form submissions",
      max_submissions: "Maximum Submissions",
      max_submissions_help:
        "Maximum number of submissions allowed for the form",
      settings_saved_successfully:
        "Your settings have been saved successfully!",
      unsaved_changes_warning:
        'You have unsaved changes. Click the "Save" button to apply changes.',
      appearance: "Appearance",
      document: "Document",
      animation: "Animation",
      unsaved_changes: "Unsaved changes",
      saving: "Saving...",
      save_changes: "Save Changes",
      pdf_file_only: "You can only upload PDF files",
      pdf_size_limit: "PDF file is too large",
      pdf_upload_success: "PDF uploaded successfully",
      pdf_upload_error: "Error occurred while uploading PDF",
      pdf_delete_success: "PDF deleted successfully",
      pdf_preview: "PDF Preview",
      pdf_download: "Download PDF",
      upload_pdf: "Upload PDF",
      drop_pdf_here: "Drop PDF file here",
      pdf_max_size: "Maximum PDF size: {{size}}",
      no_logo_available: "No logo available",
      file_type: "File Type",
      standard_form: "Standard Form",
      advanced_form: "Advanced Form",
      select_file_type: "Select File Type",
      all_types: "All Types",
      form: "Form",
      table: "Table",
      confirm_save_form: "Confirmation",
      save_confirmation_message: "Do you want to save this form?",
      form_details: "Form Details",
      field_count: "Field Count",
      fields: "fields",
      save_warning:
        "This action cannot be undone. Your changes will be permanent after the form is saved.",
      save_form: "Save Form",
      saving_form: "Saving Form...",
      loginRequiredControl:
        "Login Required Control setting to require login to fill out the form",
    },
  },
};

const savedLang = localStorage.getItem("language") || "tr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: "tr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
